import "../../../../src/content/krakow-streaming/krakow.scss";
import * as React from 'react';
export default {
  React
};